import { any, defaultTo, pipe, prop, where } from 'rambda'
import { isNotEmpty } from './guards'

export const hasProsCons = pipe(
  prop('reviewsExternal'),
  defaultTo([]),
  any(where({
    pros: isNotEmpty,
    cons: isNotEmpty,
  })),
)
